export default __webpack_public_path__ + "ebd5059bd1b002620c06f8c550810928.png";